import { IThemeColors, IThemeInfo } from "services/theme/types";
import { StateCreator } from "zustand";

export enum THEME_TYPE {
  light = 1,
  dark = 2,
}

export interface ITheme extends IThemeColors, IThemeInfo {}

interface IThemeState {
  themeType: THEME_TYPE | null;
  theme: ITheme | null;
}

interface IThemeActions {
  setThemeType: (type: THEME_TYPE) => void;
  setTheme: (theme: ITheme) => void;
}

export interface IThemeStore extends IThemeState, IThemeActions {}

export const createThemeSlice: StateCreator<IThemeStore> = (set) => ({
  themeType: null,
  theme: null,

  setThemeType: (themeType: THEME_TYPE) => {
    localStorage.setItem("theme-mode", `${themeType}`);
    set({ themeType });
  },

  setTheme: (theme: ITheme) => {
    set({ theme });
  },
});
